import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects (fetch / delete), not state
 * transitions (the saga owns the resulting `load*` / `delete*` ones).
 */

/** Load every user (dispatched by the page on mount). */
export const usersRequested = createAction('users/usersRequested');

/** Delete a user by id. */
export const deleteRequested = createAction<string>('users/deleteRequested');

/** Deactivate (`archived: true`) or reactivate (`false`) a user (#590). */
export const archiveRequested = createAction<{ id: string; archived: boolean }>(
  'users/archiveRequested',
);
